export default {
  zoneGroupPeriods: (state) => state.zoneGroupPeriods,
  zoneGroupToEdit: (state) => state.zoneGroupToEdit,
  zoneGroupInfo: (state) => state.zoneGroupInfo,
  zoneGroupZoneInfo: (state) => state.zoneGroupZoneInfo,
  zoneGroupMap: (state) => state.zoneGroupMap,
  zoneGroupMapAction: (state) => state.zoneGroupMapAction,
}



// WEBPACK FOOTER //
// ./src/store/zonegroups/getters.js